module.exports = __webpack_public_path__ + "static/media/mastercard-logo.d296d668.png";